export enum BrandId {
  BILLTECH = 'BILLTECH'
}

export interface Brand {
  id: BrandId;
  host: string;
  termsOfUseLink: string;
  privacyPolicyLink: string;
  contactUsEmail: string;
  footerVisible: boolean;
  chatEnabled: boolean;
}
